"use client";

import { c as _c } from "react/compiler-runtime";
import { TextField } from "@mui/material";
import Joi from "joi";
import React from "react";
import { ArgumentType } from "#/entities/argument/model/argumentObject";
import { argumentTypeLabels } from "#/entities/argument/model/argumentTypeLabels";
import { caseSlice } from "#/entities/argument/model/caseSlice";
import type { ArgumentObject } from "#/entities/argument/model/types";
import { BooleanToggleInput } from "#/shared/ui/atoms/BooleanToggleInput";
import { DebouncedInput } from "#/shared/ui/molecules/DebouncedInput";
import { JsonInput } from "#/shared/ui/molecules/JsonInput";
import { useAppDispatch } from "#/store/hooks";
const validationSchemaMap = {
  [ArgumentType.ARRAY]: Joi.array(),
  [ArgumentType.BINARY_TREE]: Joi.array().items(Joi.number().strict().allow(null)),
  [ArgumentType.LINKED_LIST]: Joi.array().items(Joi.number()),
  [ArgumentType.MATRIX]: Joi.array().items(Joi.array().items(Joi.number().strict(), Joi.string()).messages({
    "array.includes": "Array item at {{#label}} must be either a number or a string"
  }), Joi.string()),
  [ArgumentType.GRAPH]: Joi.array().items(Joi.array().items(Joi.number().strict()))
} as const;
export const ArgInput: React.FC<{
  arg: ArgumentObject;
}> = t0 => {
  const $ = _c(21);
  const {
    arg
  } = t0;
  const dispatch = useAppDispatch();
  let t1;
  if ($[0] !== arg || $[1] !== dispatch) {
    t1 = value => {
      dispatch(caseSlice.actions.updateArgument({
        ...arg,
        input: value
      }));
    };
    $[0] = arg;
    $[1] = dispatch;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleChange = t1;
  switch (arg.type) {
    case ArgumentType.ARRAY:
    case ArgumentType.BINARY_TREE:
    case ArgumentType.LINKED_LIST:
    case ArgumentType.MATRIX:
    case ArgumentType.GRAPH:
      {
        const t2 = argumentTypeLabels[arg.type];
        const t3 = validationSchemaMap[arg.type];
        let t4;
        if ($[3] !== arg.input || $[4] !== handleChange || $[5] !== t2 || $[6] !== t3) {
          t4 = <JsonInput label={t2} value={arg.input} onChange={handleChange} validationSchema={t3} size="small" />;
          $[3] = arg.input;
          $[4] = handleChange;
          $[5] = t2;
          $[6] = t3;
          $[7] = t4;
        } else {
          t4 = $[7];
        }
        return t4;
      }
    case ArgumentType.STRING:
      {
        let t2;
        if ($[8] !== arg.input || $[9] !== handleChange) {
          t2 = <DebouncedInput label={argumentTypeLabels.string} fullWidth={true} size="small" onChange={handleChange} value={arg.input} />;
          $[8] = arg.input;
          $[9] = handleChange;
          $[10] = t2;
        } else {
          t2 = $[10];
        }
        return t2;
      }
    case ArgumentType.BOOLEAN:
      {
        let t2;
        if ($[11] !== arg.input || $[12] !== handleChange) {
          t2 = <BooleanToggleInput value={arg.input} onChange={handleChange} />;
          $[11] = arg.input;
          $[12] = handleChange;
          $[13] = t2;
        } else {
          t2 = $[13];
        }
        return t2;
      }
  }
  const t2 = argumentTypeLabels[arg.type];
  const t3 = arg.type === ArgumentType.NUMBER ? "number" : "text";
  let t4;
  if ($[14] !== handleChange) {
    t4 = ev => handleChange(ev.target.value);
    $[14] = handleChange;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== arg.input || $[17] !== t2 || $[18] !== t3 || $[19] !== t4) {
    t5 = <TextField label={t2} value={arg.input} type={t3} fullWidth={true} size="small" onChange={t4} />;
    $[16] = arg.input;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
};